













import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {}})
export default class Cover extends Vue {
  @Prop() readonly section!: ListSection;
  @Prop({default: false}) readonly fixed!: boolean;

  title: string = '';

  @Watch('section', {immediate: true, deep: true})
  onData() {
    this.title = this.section.Title;
  }

  @Watch('title', {immediate: false, deep: false})
  titleChanged() {
    if (this.section.Title === this.title) {
      return;
    }
    this.update();
  }

  update() {
    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Title: this.title,
    };

    dokument.updateItem(s);
  }
}
